module.exports = __webpack_public_path__ + "img/shopify_logo.41452e51.png";